import type { ReactNode } from 'react';
import Footer from '../Footer';
import MarketingHeader from './MarketingHeader';

interface MarketingLayoutProps {
  children: ReactNode;
  showSkipLink?: boolean;
}

export default function MarketingLayout({
  children,
  showSkipLink = true,
}: MarketingLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {showSkipLink && (
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
      )}
      <MarketingHeader />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  );
}
